import React, { useState } from 'react'
import { Button } from 'semantic-ui-react'
import Accordion from '../../common/Accordion'

export const AnnualLeaveNoticeFooter = (props) => {
  const [expended, setExpended] = useState(true)

  return (
    <Accordion
      heading="Your template letter is now ready"
      expanded={expended}
      onClick={() => setExpended(!expended)}
    >
      <p>You can download your letter to your device.</p>
      <p>
        This will create a Word document that you can review and edit before you
        send it to your employee.
      </p>
      <p>
        You should carefully check the terms in your template Notice of
        requirement to take annual leave letter. You may wish to seek
        professional advice to make sure they are suitable for your business.
      </p>
      <h2>Save to your device</h2>
      <Button className="ui is-primary button" onClick={props.handleDownload}>
        Download
      </Button>

      <p>
        Use our{' '}
        <a
          href="https://calculate.fairwork.gov.au/leave"
          target="_blank"
          rel="noreferrer"
          className="external-link"
        >
          Leave Calculator
        </a>{' '}
        to calculate leave balances and annual leave loading entitlements for
        your employees.
      </p>
      <p>
        Find out more about{' '}
        <a
          href="https://www.fairwork.gov.au/leave/annual-leave/payment-for-annual-leave"
          target="_blank"
          rel="noreferrer"
          className="external-link"
        >
          payment of annual leave
        </a>
        .
      </p>
    </Accordion>
  )
}
